<template>
  <div>
    <template v-if="showNoStoriesAlert">
      <b-alert
        class="mt-1"
        show
        variant="warning"
      >
        There are no stories to edit
      </b-alert>
    </template>
    <template v-else>
      <ActivatePathStoryPicker />
      <PanelPicker />
      <b-alert
        :show="showImageUploadingAlert || imageUploading"
        variant="warning"
        dismissible
        @dismissed="showImageUploadingAlert=false"
      >
        An image is uploading. Please wait for a while.
      </b-alert>
      <TTEditor
        v-if="showEditor"
        :panel="storyBuilderPanel"
        data-cy="story-input"
      />
    </template>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import TTEditor from '@/components/TipTap/wrappers/TTEditor.vue'
import ActivatePathStoryPicker from '@/components/builder/StoryEditor/ActivatePathStoryPicker.vue'
import PanelPicker from '@/components/builder/StoryEditor/PanelPicker.vue'

const components = {
  TTEditor,
  ActivatePathStoryPicker,
  PanelPicker,
}

// eslint-disable-next-line no-use-before-define
@Component<StoryEditor>({
  components,
  watch: {
    storyPath () {
      this.updateEditor()
    },
    storyBuilderPanel () {
      this.updateEditor()
    },
    defaultStoryPathToEdit () {
      this.updateEditor()
    },
  },
  beforeRouteLeave (to, from, next) {
    // Prevent navigation if there's an image still needed to be uploaded
    if (this.imageUploading) {
      this.showImageUploadingAlert = true
      next(false)
    } else {
      this.showImageUploadingAlert = false
      next()
    }
  },
})
export default class StoryEditor extends Vue {
  showEditor = true
  showImageUploadingAlert = false

  created () {
    this.$typedStore.public.display.setStoryBorder(true)
  }

  destroyed () {
    this.$typedStore.public.display.setStoryBorder(false)
  }

  get showNoStoriesAlert () {
    return this.$typedStore.primary.entities.tabs.visibleTabs.length === 0
  }

  get imageUploading () {
    return this.$typedStore.primary.entities.images.imageUploading
  }

  get storyBuilderPanel () {
    return this.$typedStore.public.display.storyBuilderPanel
  }

  get storyPath () {
    return this.$typedStore.public.display.storyPath
  }

  get defaultStoryPathToEdit () {
    return this.$typedStore.public.display.defaultStoryPathToEdit
  }

  updateEditor () {
    this.showEditor = false
    this.$nextTick(() => { this.showEditor = true })
  }
}

</script>
